import { Map } from 'immutable'
import createReucer from '@/models/createReucer'
import { SAVE_CURRENT_USER } from './actionTypes'
import User from './defines/User'
import { TODO_REFRESH } from '../socket/actionTypes';

const initializeState = Map({
  current: Map(),
  todoRefreshKey: 'initkey'
})

export default createReucer({
  [SAVE_CURRENT_USER]: (state, { payload }) =>
    state.set('current', Map(payload)),
  [TODO_REFRESH](state, { payload }) {
    return state.set('todoRefreshKey', Date.now())
  },
}, initializeState)
